//                                                  
import { repo } from '@bi/sync';
export const BookmarksRepository = repo.bm.BookmarksRepository;
export const TopicGroupMapsRepository = repo.bm.TopicGroupMapsRepository;
